'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/**
 * @ngdoc filter
 * @name amount
 *
 * @description
 * #filter
 * format a float to an amount with a suffix
 *
 * @param {float} price Price to convert to amount
 * @param {string=''} pricePrefix Add a prefix to the price i.e.: "+"
 * @param {string=''} priceSuffix Add a suffix to the price i.e.: "/month"
 * @param {boolean=false} hideDecimal If true, remove decimal part
 * @param {boolean=false} useDecimalWrapper If true, wrap two decimal digit in a sup tag
 * @return {string} Conversion of the float price to a string with $ and suffix concatenated
 */

angular.module('v-tv-package').filter('amount', function amountFilter($translate) {
    return function (price, pricePrefix, priceSuffix, hideDecimal, useDecimalWrapper) {
        if (isNaN(parseFloat(price))) {
            return price;
        }

        var _toFixed$split = (parseFloat(price) || 0).toFixed(2).split('.'),
            _toFixed$split2 = _slicedToArray(_toFixed$split, 2),
            dollars = _toFixed$split2[0],
            cents = _toFixed$split2[1];

        var lang = $translate.use();
        var prefix = (pricePrefix || '') + '$';
        var decimalSep = '.';
        var noDecimal = !!hideDecimal;
        var suffix = priceSuffix || '';
        var wrapDecimal = !!useDecimalWrapper;
        var thousandsSep = ',';

        if (lang === 'fr') {
            prefix = pricePrefix || '';
            decimalSep = ',';
            suffix = '&#8239;$' + suffix;
            thousandsSep = '&#8199;';
        }

        // Utilise 2 lookahead. 1 positif pour assurer 3 chiffres en ligne et un négatif pour assurer le multiple de 3 et ajoute le séparateur. (\B = NOT word boundary).
        dollars = dollars.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);

        if (!noDecimal && wrapDecimal) {
            cents = '<sup>' + cents + '</sup>';
        }

        return prefix + dollars + (!noDecimal ? decimalSep + cents : '') + suffix;
    };
});